<template>
  <div>
    <a-row>
      <a-tabs defaultActiveKey="1">
        <a-tab-pane tab="EVALUACIONES" key="1">
          <g-master name="evaluaciones"
                    :endpoint="evaluationMaster.endpoint"
                    :tableSetup="evaluationMaster.tableSetup"
                    :modalFieldsSetup="evaluationMaster.modalFieldsSetup"
                    @action="masterAction"
          >
            <template slot="masterModal" slot-scope="{record}">
              <a-row :gutter="[16,16]">
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" label="Descripción">
                    <a-input
                      v-decorator="['description', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item label="Fecha inicio" v-bind="fiOptions">
                    <a-date-picker style="width: 100%"
                                   v-decorator="['date_initial', { rules: [{ required: true, message: 'Valor requerido' }] }]"></a-date-picker>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item label="Fecha final" v-bind="fiOptions">
                    <a-date-picker style="width: 100%"
                                   v-decorator="['date_final', { rules: [{ required: true, message: 'Valor requerido' }] }]"></a-date-picker>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item label="Fecha apertura" v-bind="fiOptions">
                    <a-date-picker style="width: 100%"
                                   v-decorator="['date_open', { rules: [{ required: true, message: 'Valor requerido' }] }]"></a-date-picker>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item label="Fecha cierre" v-bind="fiOptions">
                    <a-date-picker style="width: 100%"
                                   v-decorator="['date_close', { rules: [{ required: true, message: 'Valor requerido' }] }]"></a-date-picker>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-dropdown endpoint="type_evaluation"
                              label="Tipo evaluación"
                              :formItemConfig="fiOptions"
                              :decorator="['id_type_evaluation', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                  >
                  </g-dropdown>
                </a-col>
              </a-row>
            </template>
          </g-master>
          <a-tabs defaultActiveKey="1">
            <a-tab-pane tab="COMPETENCIA DE ROLES" key="1"
                        v-if="$getConfigValue('NUEVO_METODO_EVALUACIONES', 'NO') === 'SI'">
              <competenciaderoles v-if="idEvaluaciones" :id_evaluation="idEvaluaciones"></competenciaderoles>
              <span v-else>Seleccione una evaluación para ver más.</span>
            </a-tab-pane>
            <a-tab-pane tab="NIVEL DE EVALUACIÓN" key="2">
              <nivel-competencia v-if="idEvaluaciones" :id_evaluation="idEvaluaciones"></nivel-competencia>
              <span v-else>Seleccione una evaluación para ver más.</span>
            </a-tab-pane>
            <a-tab-pane tab="LISTADO DE EVALUADOS" key="3">
              <evaluados v-if="idEvaluaciones" :id_evaluation="idEvaluaciones"></evaluados>
              <span v-else>Seleccione una evaluación para ver más.</span>
            </a-tab-pane>
            <!--Aqui va competencias -->
            <a-tab-pane tab="COMPETENCIAS" key="4"
                        v-if="$getConfigValue('NUEVO_METODO_EVALUACIONES', 'NO') === 'NO'">
              <competencias v-if="idEvaluaciones" :id_evaluation="idEvaluaciones"
                            :dateInitial="dateInitial"></competencias>
              <span v-else>Seleccione una evaluación para ver más.</span>
            </a-tab-pane>
            <a-tab-pane tab="HABILIDADES Y CONOCIMIENTOS" key="5">
              <skills-group v-if="idEvaluaciones" :id_evaluation="idEvaluaciones"></skills-group>
              <span v-else>Seleccione una evaluación para ver más.</span>
            </a-tab-pane>
          </a-tabs>
        </a-tab-pane>
        <a-tab-pane tab="MAESTROS" key="2">
          <tabsmaestros/>
        </a-tab-pane>
      </a-tabs>
    </a-row>
    <a-modal
      title="Programación de notificaciones"
      :visible="visibleModalNotificacionEvaluadores"
      :confirm-loading="confirmLoadingNotificacionEvaluadores"
      @cancel="visibleModalNotificacionEvaluadores = false"
      :footer="null"
    >
      <g-master name="notificacion_evaluaciones"
                :endpoint="management_skill_notif.endpoint"
                :tableSetup="management_skill_notif.tableSetup"
                :modalFieldsSetup="management_skill_notif.modalFieldsSetup"
                @action="masterActionNotificaciones"
                ref="masterNotificaciones"
                :parentData="notificacionFiltrada"
                :beforeSend="management_skill_notif.beforeSend"
      >
        <template slot="masterModal" slot-scope="{record}">
          <a-row :gutter="[16,16]">
            <a-col v-bind="colOptions">
              <a-form-item :label="$t('Fecha/hora de envio')" v-bind="fiOptions">
                <a-date-picker style="width: 100%"
                               valueFormat="Y-MM-DD 04:00:00"
                               v-decorator="['notification_date', { rules: [{ required: true, message: 'Valor requerido' }] }]"></a-date-picker>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('Roles destinados')">
                <a-select mode="tags"
                          v-decorator="['roles', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                          style="width: 100%"
                          :loading="loadingSelectRoles">
                  <a-select-option v-for="rol in rolesPermitidosNotificacion" :value="rol.description">
                    {{ rol.description }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
        </template>
      </g-master>
      <br/>
    </a-modal>
    <a-row>
    </a-row>
  </div>
</template>

<script>
  import moment from 'moment'
  import HttpUtil from '@/util/HttpUtil'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'

  export default {
    data () {
      return {
        idEvaluacionSeleccionada: null,
        colConfig2: {
          sm: 24,
          md: 24
        },
        rolesPermitidosNotificacion: [],
        formRules: {},
        loadingSelectRoles: false,
        visibleModalNotificacionEvaluadores: false,
        confirmLoadingNotificacionEvaluadores: false,
        pageTitle: 'Evaluaciones',
        visible: false,
        nombre: '',
        colOptions: {xs: 24, sm: 24},
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        evaluationMaster: {
          endpoint: 'management_skill',
          tableSetup: {
            actions: {
              actions: [
                {
                  name: 'masterEdit',
                  text: 'Editar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'edit'}
                },
                {
                  name: 'masterDelete',
                  text: 'Eliminar',
                  permisos: [],
                  props: {size: 'small', icon: 'delete', type: 'link', style: {color: 'red'}}
                },
                {
                  name: 'enviarCorreoInformacionEvaluadores',
                  text: 'Notificar evaluadores',
                  permisos: [],
                  props: {size: 'small', icon: 'mail', type: 'link', style: {color: 'purple'}}
                }
              ]
            },
            tableConfig: {
              rowKey: 'id_evaluation'
            },
            columns: [
              {title: 'Descripción', dataIndex: 'description', sorter: true},
              {title: 'Fecha inicial', dataIndex: 'date_initial_mask', sorter: true},
              {title: 'Fecha final', dataIndex: 'date_final_mask', sorter: true},
              {title: 'Fecha apertura', dataIndex: 'date_open_mask', sorter: true},
              {title: 'Fecha de cierre', dataIndex: 'date_close_mask', sorter: true},
              {title: 'Tipo evaluación', dataIndex: 'description_desc', sorter: true}
            ],
            allowSelect: true,
            selectedRows: []
          },
          modalFieldsSetup: [
            {name: 'description'},
            {name: 'date_initial', type: 'date'},
            {name: 'date_final', type: 'date'},
            {name: 'date_open', type: 'date'},
            {name: 'date_close', type: 'date'},
            {name: 'id_type_evaluation'}
          ]
        },
        management_skill_notif: {
          beforeSend: (data) => {
            data.roles = data.roles.toString()
            return data
          },
          endpoint: 'management_skill_notif',
          tableSetup: {
            actions: {
              actions: [
                {
                  name: 'masterEdit',
                  text: 'Editar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'edit'}
                },
                {
                  name: 'masterDelete',
                  text: 'Eliminar',
                  permisos: [],
                  props: {size: 'small', icon: 'delete', type: 'link', style: {color: 'red'}}
                }
              ]
            },
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Fecha de envio', dataIndex: 'notification_date_desc', sorter: true},
              {title: 'Roles destinados', dataIndex: 'roles', sorter: true},
              {title: 'Creado por', dataIndex: 'created_by', sorter: true},
              {title: 'Creado el', dataIndex: 'created_on', sorter: true},
              {title: 'Modificado por', dataIndex: 'modified_by', sorter: true},
              {title: 'Modificado el', dataIndex: 'modified_on', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'notification_date'},
            {name: 'roles'}
          ]
        }
      }
    },
    computed: {
      idEvaluaciones () {
        return this.evaluationMaster.tableSetup.selectedRows.length > 0 ? this.evaluationMaster.tableSetup.selectedRows[0].id_evaluation : null
      },
      dateInitial () {
        return this.evaluationMaster.tableSetup.selectedRows.length > 0 ? this.evaluationMaster.tableSetup.selectedRows[0].date_initial_mask : null
      },
      notificacionFiltrada () {
        return {id_evaluation: this.idEvaluacionSeleccionada}
      }
    },
    mounted () {
      this.httpClient = new HttpUtil()
      this.formRules = {
        notification_date: [{required: true, message: 'Valor requerido'}],
        roles: [{required: true, message: 'Valor requerido'}]
      }
    },
    methods: {
      masterAction (action) {
        switch (action.action) {
          case 'enviarCorreoInformacionEvaluadores':
            this.rolesPermitidosNotificacion = []
            this.visibleModalNotificacionEvaluadores = true
            this.consultarRolesDeEvaluacion(action)
            break
        }
      },
      masterActionNotificaciones (action) {
        switch (action.action) {
          case 'masterEdit':
            this.$refs.masterNotificaciones.modal.form.setFieldsValue({
              roles: action.record.roles.split(',')
            })
            break
        }
      },
      consultarRolesDeEvaluacion (action) {
        this.loadingSelectRoles = true
        this.idEvaluacionSeleccionada = action.record.id_evaluation
        this.httpClient.getInstance().get('evaluaciones/consultar_rol_por_evaluacion', {
          params: {
            id_evaluation: action.record.id_evaluation
          }
        })
          .then(response => {
            this.rolesPermitidosNotificacion = response.data
          })
          .catch(error => {
            Mensajes.error('Error', 'Error desconocido, contacte a un administrador')
          })
          .then(() => {
            this.loadingSelectRoles = false
          })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/Evaluaciones/Evaluaciones.vue